import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const featuresGuideVersionHistorySlice = createSlice({
  name: 'featuresGuideVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default featuresGuideVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = featuresGuideVersionHistorySlice.actions;
